"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERVIEW_PAYMENT_AMOUNT_CENTS = void 0;
/** Interview payment amount in cents (e.g. 200 = 2.00 EUR). Used for Stripe intent and analytics. */
exports.INTERVIEW_PAYMENT_AMOUNT_CENTS = 200;
